export default __webpack_public_path__ + "static/media/chat-svg1.faca25bc.svg";